export default "__VITE_ASSET__DiR4kXfZ__"